// vue
import { ref } from '@vue/composition-api';

// services
import { useStore } from '@/store';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';

// models
import {
    GeoRecordProjects,
} from '@/vue3/api/models/geoRecordProjectModels';

export const useGeoRecordProjectService = () => {
    // hooks
    const { apiUrl } = useStore().state;
    const axios = useAxios();

    // reactive
    const geoRecordProjects = ref<GeoRecordProjects[]>([]);

    // methods
    const getAllGeoRecordProjects = async (): Promise<GeoRecordProjects[]> => {
        const res = await axios.get(`${apiUrl}/project`);
        geoRecordProjects.value = res.data;
        return res.data;
    };

    const getGeoRecordProject = async (id: number): Promise<GeoRecordProjects> => {
        const res = await axios.get(`${apiUrl}/project/${id}`);
        return res.data;
    };

    const deleteGeoRecordProject = async (id: number) => {
        const res = await axios.deleteId(`${apiUrl}/project/${id}`);
        return res.data;
    };

    const createGeoRecordProject = async (
        projects: GeoRecordProjects,
    ): Promise<GeoRecordProjects[]> => {
        const res = await axios.post(`${apiUrl}/project`, projects);
        return res.data;
    };

    const updateGeoRecordProject = async (
        projects: GeoRecordProjects,
    ): Promise<GeoRecordProjects[]> => {
        const res = await axios.put(`${apiUrl}/project`, projects);
        return res.data;
    };

    return {
        geoRecordProjects,
        getAllGeoRecordProjects,
        getGeoRecordProject,
        deleteGeoRecordProject,
        createGeoRecordProject,
        updateGeoRecordProject,
    };
};
